// P1: Single source of truth for every drawing-related localStorage key.
// Rule: no component may hardcode an `rsc-`/`vnsc-`/`vninvestcharts-widget_` key literal —
// import the constant/builder below so key migrations stay in one place.
/** Base prefix for per-timeframe + aggregate drawing payloads. */
export const DRAWINGS_KEY_PREFIX = "rsc-drawings-v1";
function resolveDrawingsPrefix(options) {
    const base = options?.prefix ?? DRAWINGS_KEY_PREFIX;
    return options?.instanceId ? `${base}-${options.instanceId}` : base;
}
/** Source-of-truth key for the editor: one key per symbol+timeframe (D-09). */
export function drawingsKey(symbol, timeframe, options) {
    return `${resolveDrawingsPrefix(options)}-${symbol}-${timeframe}`;
}
/** Legacy aggregate read-cache key (`-{symbol}-all`). Read-only; the editor never
 * writes it (D-09). Kept for REST/backward compatibility. */
export function drawingsAllKey(symbol, options) {
    return `${resolveDrawingsPrefix(options)}-${symbol}-all`;
}
/** Default (single) style template per tool — split from named templates (D-11). */
export const TEMPLATE_DEFAULT_PREFIX = "rsc-drawing-template-default-";
/** Named style templates per tool+name — split from default templates (D-11). */
export const TEMPLATE_NAMED_PREFIX = "rsc-drawing-template-named-";
/** Index keys for named template name lists (unchanged scheme). */
export const TEMPLATE_INDEX_PREFIX = "rsc-drawing-template-index-";
/** Legacy single-namespace template prefix (pre-P1). Read for backward
 * compatibility only; new writes always use DEFAULT_/NAMED_ prefixes. */
export const TEMPLATE_LEGACY_PREFIX = "rsc-drawing-template-";
/** Drawing dock open/tab/layout state. */
export const DOCK_STATE_KEY = "vnsc-drawing-dock-state";
/** Collapsed groups in the drawing list panel. */
export const LIST_COLLAPSED_KEY = "vnsc-drawing-list-collapsed-groups";
/** Cross-hook drawing clipboard payload. */
export const WIDGET_CLIPBOARD_KEY = "vninvestcharts-widget_clipboard";
